import { buildApiUrl } from '../utils/apiConfig';
import { YouTubeVideo } from '../types/youtubeFeed';
import { apiClient } from "../utils/apiClient";

/**
 * Fetches the latest YouTube videos for the public landing page.
 * Public, unauthenticated CMS endpoint — no credentials are sent.
 * On any failure the caller receives an empty list so the section renders nothing.
 */
export async function fetchYouTubeFeed(): Promise<YouTubeVideo[]> {
    try {
        const response = await apiClient(buildApiUrl('api/cms/youtube/videos'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch YouTube feed: ${response.status}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? (data as YouTubeVideo[]) : [];
    } catch (error) {
        console.error('Error fetching YouTube feed:', error);
        return [];
    }
}
